export const ThirtyDayIcon = ({
  width = 40,
  height = 40,
  title = "Before 30-day period ends",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...props}>
    <title>{title}</title>
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M20.703 66.03V43.31c0-6.25 2.695-14.846 6.536-16.861L30 25M59.197 18.116v40.867c0 2.254-1.837 4.082-4.102 4.082H39.94c.092-2.129-.207-5.038-1.9-7.909-1.523-2.587-3.549-4.086-4.766-4.845v-7.965a4.482 4.482 0 0 0-2.702-4.11v-20.12c0-2.255 1.837-4.082 4.102-4.082h20.42c2.266 0 4.103 1.827 4.103 4.082Z"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M39.533 66.03c.116-.483.351-1.55.408-2.965.091-2.129-.208-5.038-1.9-7.909-1.523-2.587-3.55-4.085-4.767-4.845v-7.965a4.482 4.482 0 0 0-2.701-4.11 4.445 4.445 0 0 0-1.808-.378c-.806 0-1.46.648-1.46 1.45v14.76"
    />
    <path
      stroke="#5DCDFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M41.666 31.667 44.999 35l5-8.333"
    />
    <path
      stroke="#5DCDFF"
      strokeLinecap="round"
      d="M40 46.667h11.667M40 41.667h11.667"
    />
  </svg>
);
